// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"54aaca20","239":"13e14d85","389":"27b269da","453":"9994f42d","455":"16c03f78","857":"baf6405d","977":"c8948c4b"}[chunkId] + ".chunk.js";
};